import * as React from 'react';
import Chip from '@mui/material/Chip';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import { useHistory } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import Typography from '@mui/material/Typography';
import BasicFilm from 'react-film';

function ExamplesView() {
  let history = useHistory();
  const [forSaleImages, setForSaleImages] = React.useState([]);
  const [canvasImages, setCanvasImages] = React.useState([]);
  const [wreathImages, setWreathImages] = React.useState([]);
  const [flowerImages, setFlowerImages] = React.useState([]);
  const [loading, setLoading] = React.useState([]);

  React.useEffect(() => {
    loadImages();
  }, []);

  const loadImages = async () => {
    try {
      const canvasForSaleImages = await filterImportAll(
        require.context('../assets/images/for_sale')
      );
      const wreathsForSaleImages = await filterWreathsImportAll(
        require.context('../assets/images/for_sale')
      );
      const wreathImportImages = await importAll(
        require.context('../assets/gallery/Wreaths')
      );
      const flowerImportImages = await importAll(
        require.context('../assets/gallery/Flowers')
      );
      const canvasImportImages = await importAll(
        require.context('../assets/gallery/Canvas')
      );
      setForSaleImages([...Object.keys(canvasForSaleImages)]);
      setWreathImages({ ...wreathImportImages, ...wreathsForSaleImages });
      setCanvasImages({ ...canvasImportImages, ...canvasForSaleImages });
      setFlowerImages(flowerImportImages);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const importAll = async (r) => {
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
    });
    return images;
  };

  const filterWreathsImportAll = async (r) => {
    let images = {};
    r.keys().map((item, index) => {
      if (item.includes('primary') && item.includes('wreath')) {
        images[item.replace('./', '')] = r(item);
      }
    });
    return images;
  };
  const filterImportAll = async (r) => {
    let images = {};
    r.keys().map((item, index) => {
      if (
        item.includes('primary') &&
        !item.includes('wreath') &&
        !item.includes('arrangement')
      ) {
        images[item.replace('./', '')] = r(item);
      }
    });
    return images;
  };

  const pageHeader = {
    title: 'Gallery',
    description:
      "Multiple lines of text that form the lede, informing new readers quickly and efficiently about what's most interesting in this post's contents.",
    image: 'https://source.unsplash.com/random',
    imageText: 'main image description',
  };
  return (
    <React.Fragment>
      <Container
        disableGutters
        component='main'
        maxWidth='2xl'
        sx={{
          display: 'flex',
          width: '100%',
          marginBottom: 12,
          alignItems: 'center',
          justifyContent: 'space-around',
          flexDirection: 'column',
        }}
      >
        <Container disableGutters maxWidth='2xl' component='main'>
          <PageHeader post={pageHeader} />
        </Container>
        <Container container spacing={1}>
          <Typography
            sx={{ my: 1, fontSize: 40, mt: { xs: 5, md: 0 } }}
            variant='primary'
            component='div'
            align='center'
          >
            Canvas Art
          </Typography>
          <BasicFilm height={316}>
            {canvasImages &&
              Object.keys(canvasImages).map((image, idx) => {
                return (
                  <div
                    key={idx}
                    style={{
                      position: 'relative',
                      textAlign: 'center',
                      color: 'blue',
                    }}
                  >
                    <img
                      src={canvasImages[image].default}
                      alt={image}
                      width={250}
                    />
                    <Chip
                      label={'For Sale'}
                      sx={{
                        display: !forSaleImages.includes(image) && 'none',
                        position: 'absolute',
                        top: 10,
                        right: 5,
                        background: '#ffff66',
                      }}
                    />
                  </div>
                );
              })}
          </BasicFilm>
        </Container>
        <Container container spacing={1}>
          <Typography
            sx={{ my: 1, fontSize: 40 }}
            variant='primary'
            component='div'
            align='center'
          >
            Wreaths
          </Typography>
          <BasicFilm height={316}>
            {wreathImages &&
              Object.keys(wreathImages).map((image, idx) => (
                <img
                  key={idx}
                  src={wreathImages[image].default}
                  alt={image}
                  width={250}
                />
              ))}
          </BasicFilm>
        </Container>
        <Container spacing={1}>
          <Typography
            sx={{ my: 1, fontSize: 40 }}
            variant='primary'
            component='div'
            align='center'
          >
            Flowers
          </Typography>
          <BasicFilm height={316}>
            {flowerImages &&
              Object.keys(flowerImages).map((image, idx) => (
                <img
                  key={idx}
                  src={flowerImages[image].default}
                  alt={image}
                  height={400}
                />
              ))}
          </BasicFilm>
        </Container>
      </Container>
    </React.Fragment>
  );
}

export default function Pricing() {
  return <ExamplesView />;
}
